import React from "react";

export function SecurityEmptyState({ message }) {
  return <div className="security-state security-empty">{message}</div>;
}
